// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ngOuU","row":"footer_row__IUiv7"};